module.exports = __webpack_public_path__ + "static/img/coma2.728ccd24.svg";